const classes = [ '-empty', '-half', '-full' ];

export const getStarModifierClass = (star) => // 0, 0.5, 1
  classes[star * 2];

const getDecimal = (number) =>
  parseFloat(`0.${String(number).split('.')[1]}`);

const getFixed = (number) =>
  parseInt(String(number).split('.')[0], 10);


export const starsDetailed = (rating) => {
  const stars = [ 0, 0, 0, 0, 0 ];
  const ratingFixed = getFixed(rating);
  const ratingDecimal = getDecimal(rating);

  for (let i = 0; i < ratingFixed; i++) {
    stars[i] = 1;
  }

  if (ratingFixed < stars.length) {
    stars[ratingFixed] = ratingDecimal;
  }

  return stars;
};

export default (rating) => {
  const stars = [ 0, 0, 0, 0, 0 ];

  if (rating >= 1) {
    stars[0] = 1;
  } else if (rating) {
    stars[0] = 0.5;
  }

  if (rating >= 2) {
    stars[1] = 1;
  } else if (rating >= 1.45) {
    stars[1] = 0.5;
  }

  if (rating >= 3) {
    stars[2] = 1;
  } else if (rating >= 2.45) {
    stars[2] = 0.5;
  }

  if (rating >= 4) {
    stars[3] = 1;
  } else if (rating >= 3.45) {
    stars[3] = 0.5;
  }

  if (rating >= 4) {
    stars[3] = 1;
  } else if (rating >= 3.45) {
    stars[3] = 0.5;
  }

  if (rating >= 5) {
    stars[4] = 1;
  } else if (rating >= 4.45) {
    stars[4] = 0.5;
  }

  return stars;
};



// WEBPACK FOOTER //
// ./src/lib/stars.js